import images from 'src/common/images';
import { FilEstimaDetail } from 'src/common/interfaces';
import { MitsumoriType } from 'src/common/number-enum';
import EstimaInput from './estima-input';
import { TableHeader } from './quotation-input';

export interface RowMeisaiTableProps extends React.InputHTMLAttributes<HTMLInputElement> {
  dataField: any;
  arrayCompare: TableHeader[];
  renderDeleteOnEndRow?: boolean;
  onChangeRow?: (data: FilEstimaDetail) => void;
  onDeleteClick?: (hinCode: number) => void;
  isFixedRow?: boolean;
  rowType?: number;
  isFreeName?: number;
}

const RowMeisaiTable = ({
  dataField,
  arrayCompare,
  renderDeleteOnEndRow,
  onChangeRow,
  onDeleteClick,
  isFixedRow,
  rowType,
  isFreeName,
}: RowMeisaiTableProps) => {
  const tableKeys = arrayCompare.map((item: TableHeader) => item.data);
  const rowLength = tableKeys.length - 1;
  const handleDisableInput = (key: string | number) => {
    if (dataField?.isFreeInput) return false;
    switch (key) {
      case 'esd_suryo':
      case 'esd_net_rate':
      case 'esd_net_reason':
        return false;
    }
    return dataField?.isReadOnly || true;
  };

  const disabledInputRowMeisai = (key: string | number) => {
    if (isFreeName === 1 && key === 'esd_hin_nm') return false;
    else return (isFixedRow && rowType !== MitsumoriType.DISCOUNT) || handleDisableInput(key);
  };
  const handleData = (key: string | number, value: any) => {
    let newData = { ...dataField };

    if (dataField?.isFreeInput) {
      switch (key) {
        case 'esd_standard_price':
          newData = {
            ...newData,
            esd_standard_price: value,
            esd_net_price: Math.floor((value * dataField?.esd_net_rate) / 100),
          };
          break;
        case 'esd_net_rate':
          newData = {
            ...newData,
            esd_net_rate: value,
            esd_net_price: Math.floor((newData.esd_standard_price * value) / 100),
          };
          break;
        default:
          newData = {
            ...newData,
            [key]: value,
          };
      }
    } else {
      if (key === 'esd_suryo') {
        newData = {
          ...newData,
          esd_suryo: value,
          esd_standard_price: dataField?.esd_product_price * value,
          esd_maintenance_price: dataField?.mhi_maintenance_price * value,
          esd_net_price: Math.floor((dataField?.esd_product_price * value * dataField?.esd_net_rate) / 100),
        };
      } else if (key === 'esd_net_rate') {
        newData = {
          ...newData,
          esd_net_rate: value,
          esd_net_price: Math.floor((dataField?.esd_product_price * dataField?.esd_suryo * value) / 100),
        };
      } else {
        newData = {
          ...newData,
          [key]: value,
        };
      }
    }

    return {
      ...newData,
    };
  };

  return (
    <>
      {tableKeys.map((key: string | number, index: number) => {
        return (
          <td key={index} className={`text-right border-l-[1px] border-[#ccc] border-b-[1px] py-2`}>
            {!(index === rowLength && renderDeleteOnEndRow) && (
              <EstimaInput
                value={dataField?.[`${key}`] || ''}
                className="!w-full bg-transparent disabled:bg-transparent"
                onChangeInput={(value) => onChangeRow?.(handleData(key, value))}
                disabled={disabledInputRowMeisai(key)}
                {...dataField?.rowInputSettings?.[key]}
              />
            )}
            {index === rowLength && dataField?.esd_hin_kb && renderDeleteOnEndRow && (
              <div className="flex justify-center">
                <img
                  src={images.icDelete}
                  alt="delete_icon"
                  className="w-[20px] cursor-pointer"
                  onClick={() => onDeleteClick?.(dataField?.esd_hin_cd)}
                />
              </div>
            )}
          </td>
        );
      })}
    </>
  );
};

export default RowMeisaiTable;
